import { wait } from '@cgs/shared';
import { DATA_ACCESS_SERVICE_TOKEN } from '@cgs/data-access';
import { MachineStateDto } from '@cgs/provider-cgs';
import { TrifectaDemoPlayResponseDto } from '../../../models/trifecta-dto';
import { TrifectaGameHook } from './trifecta-game-hook';
import { TrifectaDemoDataAccessService } from '../services/trifecta-demo-data-access.service';

export class TrifectaDemoGameHook extends TrifectaGameHook {
  private readonly dataAccessService: TrifectaDemoDataAccessService;

  constructor(...args: ConstructorParameters<typeof TrifectaGameHook>) {
    super(...args);

    this.dataAccessService =
      this.container.resolve<TrifectaDemoDataAccessService>(DATA_ACCESS_SERVICE_TOKEN);
  }

  protected override onInsufficientFundsError(): void {
    this.dataAccessService.abortCurrentRequest();
  }

  protected async handlePlay(
    response: TrifectaDemoPlayResponseDto | Error,
    onSuccess: () => void,
    onError: (err: string) => void
  ): Promise<void> {
    if (response instanceof Error) {
      return onError(response.message);
    }

    this.dataAccessService.nextSpins(response.spins);

    this.checkAutoplayConditions(response.spins[0]);

    await this.roundFinished;
    await this.trifectaSDKAdapter.acknowledgeSpins();
    await this.waitRoundEnd(response.spins[response.spins.length - 1]);

    onSuccess();
  }

  protected waitRoundEnd(_spin: MachineStateDto): Promise<void> {
    return wait(1);
  }

  // TODO: type the response same as in handlePlay once Trifecta reworks the
  // gamble response shape on their side (SDK/backend refactoring)
  protected async handlePlayGamble(
    response: any,
    onSuccess: () => void,
    onError: (err: string) => void
  ): Promise<void> {
    if (response instanceof Error) {
      return onError(response.message);
    }

    this.dataAccessService.nextSpins(response.spins.map((item: any) => item.spin));

    const payout = response.spins[0]?.spin?.gambleInfo?.result?.payout || 0;

    if (payout) {
      this.trifectaSDKAdapter.addWin(
        payout / Math.pow(10, this.trifectaSDKAdapter.launchParams.currencyDecimals)
      );
    }

    await this.trifectaSDKAdapter.acknowledgeSpins();

    onSuccess();
  }
}
